import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";
import Navbar from "../../Navbar/Navbar";
import baseURL from "../../config";
import FormIModal from "../Modals/FormIModal.jsx";
import COCmodal from "../Modals/COCmodal.jsx";
import SignOnModal from "../Modals/SignOnModal.jsx";
import TransferModal from "../Modals/TransferModal";
import SignOffModal from "../Modals/SignOffModal";
import DepartureModal from "../Modals/DepartureModal.jsx";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

const CircleButton = styled(Button)(({ theme }) => ({
  width: 100,
  height: 100,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textTransform: "none",
  fontSize: "1rem",
  fontWeight: "bold",
  boxShadow: theme.shadows[3],
  transition: "0.3s",
  "&:hover": {
    boxShadow: theme.shadows[6],
  },
}));

const SignInSignOff = () => {
  const [contractDetails, setContractDetails] = useState([]);
  const [cocDetails, setCocDetails] = useState([]);
  const [signonDetails, setsignonDetails] = useState([]);
  const [transferDetails, setTransferDetails] = useState([]);
  const [signoffDetails, setSignoffDetails] = useState([]);
  const [departureDetails, setDepartureDetails] = useState([]);
  const [activeModal, setActiveModal] = useState(null);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [error, setError] = useState(null);
  const [pendingCounts, setPendingCounts] = useState(0);
  const [pendingsignoffCounts, setPendingsignoffCounts] = useState(0);
  const Navigate = useNavigate()

  useEffect(() => {
    const fetchPendingCounts = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${baseURL}/api/getAllPendingSignOn`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPendingCounts(res?.data?.pendingCount);

      } catch (error) {
        console.error("Error fetching pending counts:", error);
      }
    };
    const fetchPendingSignoffCounts = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(`${baseURL}/api/getAllPendingSignOff`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        // console.log("res", res.data)
        setPendingsignoffCounts(res?.data?.pendingCount);

      } catch (error) {
        console.error("Error fetching pending counts:", error);
      }
    };


    fetchPendingCounts();
    fetchPendingSignoffCounts();
  }, []);

  useEffect(() => {
    if (location.state?.openFormI) {
      handleFormIClick();
    }
  }, [location.state]);

  const handleFormIClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.get(`${baseURL}/api/getContractsWithForm1`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setContractDetails(response.data.data || []);
      setActiveModal("formI");
    } catch (error) {
      console.error("Error fetching contract details:", error);
      setError(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleCOCClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(`${baseURL}/api/getAllLatestStatusByType/coc`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("Fetched COC data:", response.data.data);
      setCocDetails(response.data.data || []);
      setActiveModal("coc");
    } catch (error) {
      console.error("Error fetching COC data:", error.response?.data || error.message);
      if (error.response?.data?.message === "No records found where the latest update is 'coc'") {
        setCocDetails([]);
        setActiveModal("coc");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSignOnClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(`${baseURL}/api/getAllLatestStatusByType/signOn`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setsignonDetails(response.data.data || []);
      setActiveModal("signOn");
    } catch (error) {
      console.error("Error fetching Sign On data:", error.response?.data || error.message);
      setsignonDetails([]);
      setActiveModal("signOn");
    } finally {
      setLoading(false);
    }
  };

  const handleTransferClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(`${baseURL}/api/getAllLatestStatusByType/transferDate`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setTransferDetails(response.data.data || []);
      setActiveModal("transfer");
    } catch (error) {
      console.error("Error fetching Transfer data:", error.response?.data || error.message);
      setTransferDetails([]);
      setActiveModal("transfer");
    } finally {
      setLoading(false);
    }
  };

  const handleSignOffClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) return console.error("No token found");

      const response = await axios.get(`${baseURL}/api/getAllLatestStatusByType/signOff`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSignoffDetails(response.data.data || []);
      setActiveModal("signOff");
    } catch (error) {
      console.error("Error fetching Sign Off data:", error.response?.data || error.message);
      setSignoffDetails([]);
      setActiveModal("signOff");
    } finally {
      setLoading(false);
    }
  };

  const handleDepartureClick = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const response = await axios.get(`${baseURL}/api/getAllLatestStatusByType/departure`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setDepartureDetails(response.data.data || []);
      setActiveModal("departure");
    } catch (error) {
      console.error("Error fetching departure data:", error.response?.data || error.message);
      setDepartureDetails([]);
      setActiveModal("departure");
    } finally {
      setLoading(false);
    }
  };

  const AnimatedBadge = styled("div")(({ theme }) => ({
    position: "absolute",
    top: -28,
    right: -18,
    background: "rgba(244, 67, 54, 0.85)", // red tone
    backdropFilter: "blur(8px)",
    border: "1px solid rgba(255, 255, 255, 0.3)",
    color: "#fff",
    borderRadius: "20px",
    padding: "6px 14px",
    fontSize: "0.75rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
    boxShadow: "0 0 12px rgba(244, 67, 54, 0.4)", // red glow
    animation: "pulse 2s ease-in-out infinite, fadeInScale 0.4s ease-out forwards",
    opacity: 0,
    transform: "scale(0.9)",

    "@keyframes pulse": {
      "0%, 100%": { boxShadow: "0 0 12px rgba(244, 67, 54, 0.4)" },
      "50%": { boxShadow: "0 0 16px rgba(244, 67, 54, 0.6)" },
    },

    "@keyframes fadeInScale": {
      "0%": { opacity: 0, transform: "scale(0.9)" },
      "100%": { opacity: 1, transform: "scale(1)" },
    },
  }));


  return (
    <>
      <Navbar />
      {error && (
        <Box p={4} textAlign="center" bgcolor="#fdecea" color="#b71c1c">
          <Typography color="error" variant="h6">
            {error}
          </Typography>
        </Box>
      )}

      <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Sign On & Sign Off Actions
        </Typography>
        <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
          <CircleButton variant="contained" color="primary" onClick={handleFormIClick}>
            Form I
          </CircleButton>
          <CircleButton variant="contained" color="secondary" sx={{ fontSize: "0.7rem" }} onClick={handleCOCClick}>
            Commencement
          </CircleButton>
          <Box position="relative" display="inline-flex">
            <CircleButton variant="contained" color="success" onClick={handleSignOnClick}>
              Vessel Sign On
            </CircleButton>
            {pendingCounts > 0 && (
              <Tooltip title="To complete Sign On: Upload Form I → Add COC Date → Add Sign On Date in COC Details">
                <AnimatedBadge>Pending Sign On {pendingCounts}</AnimatedBadge>
              </Tooltip>
            )}
          </Box>
          <CircleButton variant="contained" color="warning" onClick={handleTransferClick}>
            Transfer
          </CircleButton>
          <Box position="relative" display="inline-flex">
            <CircleButton variant="contained" color="error" onClick={handleSignOffClick}>
              Vessel Sign Off
            </CircleButton>
            {pendingsignoffCounts > 0 && (
              <Tooltip title="To complete Sign Off: Upload Form I → Add COC Date → Add Sign On Date → Add Sign Off Date in Sign On Details">
                <AnimatedBadge>Pending Sign Off {pendingsignoffCounts}</AnimatedBadge>
              </Tooltip>
            )}
          </Box>
          <CircleButton variant="contained" color="info" onClick={handleDepartureClick}>
            Arrival
          </CircleButton>
        </Box>
      </Box>
      <Box sx={{ p: 2 }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => Navigate("/getAllPendingSignOn")}
          sx={{ mr: 2 }}
        >
          Export SignOn Details
        </Button>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => Navigate("/PendingSignOffList")}
        >
          Export SignOff Details
        </Button>
      </Box>


      {/* Loader */}
      {loading && (
        <Box display="flex" justifyContent="center" alignItems="center" mt={6} minHeight="150px">
          <CircularProgress />
        </Box>
      )}

      {/* Modals */}
      {activeModal === "formI" && (
        <FormIModal open={true} setOpen={() => setActiveModal(null)} contractDetails={contractDetails} />
      )}
      {activeModal === "coc" && (
        <COCmodal open={true} setOpen={() => setActiveModal(null)} cocDetails={cocDetails} />
      )}
      {activeModal === "signOn" && (
        <SignOnModal open={true} setOpen={() => setActiveModal(null)} signonDetails={signonDetails} />
      )}
      {activeModal === "transfer" && (
        <TransferModal open={true} setOpen={() => setActiveModal(null)} transferDetails={transferDetails} />
      )}
      {activeModal === "signOff" && (
        <SignOffModal open={true} setOpen={() => setActiveModal(null)} signoffDetails={signoffDetails} />
      )}
      {activeModal === "departure" && (
        <DepartureModal open={true} setOpen={() => setActiveModal(null)} departureDetails={departureDetails} />
      )}
    </>
  );
};

export default SignInSignOff;
